import { render, staticRenderFns } from "./incubatorList.vue?vue&type=template&id=2cb5054e&"
import script from "./incubatorList.vue?vue&type=script&lang=js&"
export * from "./incubatorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports